import React,{useState} from 'react';
import { motion } from "framer-motion";
import { FaCheckCircle, FaLock, FaBuilding } from "react-icons/fa";
import { FaShieldAlt, FaUserFriends, FaServer, FaDesktop, FaClipboardCheck, FaHeadphones,FaDatabase  } from 'react-icons/fa';
import {
  Zap,
  Globe,
  Cloud,
  Key,
  IdCard,
  Video,
  Database,
  Landmark,
  Shield,
  UserCheck,
  ShieldAlert,
  HelpCircle  
} from 'lucide-react';
import { 
  FiShield, FiUserCheck,FiLayers, FiGlobe
} from 'react-icons/fi';
import {
  FaPhoneAlt,
  FaArrowRight,
  FaEnvelopeOpenText,
  FaHeadset
} from "react-icons/fa";
const OnboardingStack = () => {

  const features = [
  { icon: <IdCard size={24} color="#fff" />, title: "Aadhaar eKYC", desc: "PAN & AADHAAR Verification", bg: "#3b82f6" },
  { icon: <Video size={24} color="#fff" />, title: "Video KYC", desc: "RBI Compliant", bg: "#8b5cf6" },
  { icon: <Database size={24} color="#fff" />, title: "Central KYC", desc: "Unified Databas   e", bg: "#6366f1" },
  { icon: <Landmark size={24} color="#fff" />, title: "Co-operative Bank", desc: "Payment Solutions", bg: "#10b981" },
  { icon: <Shield size={24} color="#fff" />, title: "Data Vault", desc: "Secure Storage", bg: "#ef4444" },
  // { icon: <Wallet size={24} color="#fff" />, title: "India Loan", desc: "Lending Platform", bg: "#f59e0b" },
  { icon: <UserCheck size={24} color="#fff" />, title: "Digital Onboarding", desc: "Customer Journey", bg: "#14b8a6" },
  { icon: <ShieldAlert size={24} color="#fff" />, title: " Risk Management", desc: "Fraud Prevention", bg: "#fb923c" },
  // { icon: <Smartphone size={24} color="#fff" />, title: "TAB Banking", desc: "Mobile Solutions", bg: "#06b6d4" },
  { icon: <HelpCircle size={24} color="#fff" />, title: "Grievance System", desc: "Customer Care", bg: "#ec4899" },
];

const stats = [
  { icon: <Globe size={28} color="#3b82f6" />, label: "Financial Services", value: "10+" },
  { icon: <Zap size={28} color="#f59e0b" />, label: "Uptime Guarantee", value: "99.9%" },
  { icon: <Key size={28} color="#10b981" />, label: "Encryption", value: "256-bit" },
  { icon: <Cloud size={28} color="#8b5cf6" />, label: "Support", value: "24/7" },
];

const FeatureCard = ({ item }) => (
  <div style={{
    background: 'white',
    padding: '1.5rem 1rem',
    borderRadius: '1rem',
    boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  }}>
    <div style={{
      width: '48px',
      height: '48px',
      borderRadius: '12px',
      backgroundColor: item.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1rem',
      marginBottom:"1rem"
    }}>
      {item.icon}
    </div>
    <h4 style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b', marginBottom: '0.3rem' }}>{item.title}</h4>
    <p style={{ fontSize: '16px', color: '#64748b' }}>{item.desc}</p>
  </div>
);
 const topCards = [
    { title: 'Bank / PPI', color: '#059669', letter: 'B' },
    { title: 'Bill Pay', color: '#3b82f6', letter: 'B' },
    { title: 'Payment Aggregator & Payment Gateway', color: '#10b981', letter: 'P' },
    { title: 'Digital Bank', color: '#f59e0b', letter: 'D' },
    { title: 'Govt. Inst. & Regulators', color: '#8b5cf6', letter: 'G' },
    { title: 'Sanction Lists & Transaction Monitoring', color: '#ef4444', letter: 'S' },
  ];

  const bottomCards = [
    { title: 'Virtual Accounts', color: '#10b981', letter: 'V' },
    { title: 'Payments', color: '#3b82f6', letter: 'P' },
    { title: 'Cards', color: '#06b6d4', letter: 'C' },
    { title: 'Lending', color: '#f59e0b', letter: 'L' },
    { title: 'KYC', color: '#8b5cf6', letter: 'K' },
    { title: 'AML', color: '#ef4444', letter: 'A' },
  ];


const BaasCard = ({ title, color, letter }) => (
  <div style={{
    background: '#ffffff',
    padding: '1.2rem',
    borderRadius: '1rem',
    width: '160px',
    textAlign: 'center',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
    transition: '0.3s',
  }}>
    <div style={{
      width: '48px',
      height: '48px',
      margin: '0 auto 0.5rem',
      borderRadius: '9999px',
      backgroundColor: color,
      color: 'white',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.1rem'
    }}>{letter}</div>
    <p style={{ fontSize: '0.9rem', fontWeight: '500', color: '#1e293b' }}>{title}</p>
  </div>
);

  const glassStyle = {
    background: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "24px",
    boxShadow: "0 10px 30px -10px rgba(0,0,0,0.05)"
  };

    const badgeStyle = {
  backgroundColor: '#f5f5f5',
  padding: '0.75rem 1.5rem',
  borderRadius: '999px',
  fontSize: '1rem',
  fontWeight: 500,
  color: '#000',
  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
};
const services = [
    {
      icon: <FaShieldAlt size={24} color="white" />,
      title: 'AUA/KUA Authentication',
      desc: 'Real-time Aadhaar authentication with biometric and demographic verification',
      bgColor: '#1E40AF', // Blue
    },
    {
      icon: <FaUserFriends size={24} color="white" />,
      title: 'eKYC & Biometric Authentication',
      desc: 'Streamlined customer onboarding with instant identity verification',
      bgColor: '#047857', // Green
    },
    {
      icon: <FaServer size={24} color="white" />,
      title: 'Infra & Data Center Management',
      desc: 'Enterprise-grade infrastructure with redundancy and disaster recovery',
      bgColor: '#9333EA', // Purple
    },
    {
      icon: <FaDesktop size={24} color="white" />,
      title: 'Production Environment Monitoring',
      desc: '24/7 real-time monitoring with automated alerts and response systems',
      bgColor: '#DC2626', // Red
    },
    {
      icon: <FaClipboardCheck size={24} color="white" />,
      title: 'Audit & Compliance Handling',
      desc: 'Complete audit trails and regulatory compliance management',
      bgColor: '#F59E0B', // Amber
    },
    {
      icon: <FaHeadphones size={24} color="white" />,
      title: '24/7 Technical Support',
      desc: 'Round-the-clock expert support for seamless operations',
      bgColor: '#0E7490', // Cyan
    },
  ];
 const items = [
    {
      icon: <FaShieldAlt size={24} color="white" />,
      title: 'ISO/IEC 27001',
      desc: 'Information security management system certification',
      bgColor: '#1D4ED8', // Blue
    },
    {
      icon: <FaCheckCircle size={24} color="white" />,
      title: 'UIDAI Compliance',
      desc: 'Full adherence to UIDAI guidelines and regulations',
      bgColor: '#047857', // Green
    },
    {
      icon: <FaLock size={24} color="white" />,
      title: 'End-to-End Encryption',
      desc: 'Advanced encryption protocols for data protection',
      bgColor: '#9333EA', // Purple
    },
    {
      icon: <FaDatabase size={24} color="white" />,
      title: 'Real-time Monitoring',
      desc: 'Continuous monitoring with automated threat detection',
      bgColor: '#F59E0B', // Amber
    },
  ];

   const HoverableInfoCard = ({ tag, tagColor, title, description }) => {
    const [hovered, setHovered] = useState(false);
  
    return (
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          position: 'relative',
          backgroundColor: '#ffffff',
          borderRadius: '1rem',
          padding: '2rem',
          boxShadow: '0 10px 15px rgba(0, 0, 0, 0.05)',
          textAlign: 'left',
          transition: 'transform 0.3s ease',
          cursor: 'pointer',
        }}
      >
        {/* Top-right circle */}
        <div
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            width: '1rem',
            height: '1rem',
            borderRadius: '50%',
            backgroundColor: hovered ? '#efa844ff' : '#e2e8f0',
            transition: 'background-color 0.3s ease',
          }}
        ></div>
  
        <span
          style={{
            backgroundColor: tagColor,
            color: '#ffffff',
            fontSize: '16px',
            fontWeight: '600',
            padding: '0.25rem 0.75rem',
            borderRadius: '9999px',
            display: 'inline-block',
            marginBottom: '1rem',
          }}
        >
          {tag}
        </span>
  
        <h4
          style={{
            fontSize: '16px',
            fontWeight: 600,
            color: '#4b4b4cff',
            marginBottom: '1rem',
          }}
        >
          {title}
        </h4>
  
        <p
          style={{
            fontSize: '16px',
            color: '#475569',
          }}
        >
          {description}
        </p>
      </div>
    );
  };
  return (
    <div style={{ fontFamily: "'Inter', sans-serif", backgroundColor: '#fff', color: '#0f172a' }}>
      
      {/* 1. HERO SECTION: USER-FRIENDLY VALUE PROP */}
<div
        style={{
          width: "100%",
          background: "linear-gradient(to right, #e9fdf8ff, #dee1f7ff)",
          padding: "60px 20px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "40px",
          }}
        >
          <style>
            {`
              @keyframes slideInLeft {
                0% { transform: translateX(-50px); opacity: 0; }
                100% { transform: translateX(0); opacity: 1; }
              }
              @keyframes zoomIn {
                0% { transform: scale(0.8); opacity: 0; }
                100% { transform: scale(1); opacity: 1; }
              }
              .animated-left { animation: slideInLeft 1s ease-out forwards; }
              .zoom-in { animation: zoomIn 1s ease-out forwards; }
              
              .support-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                gap: 24px;
                max-width: 1200px;
                margin: 0 auto;
              }
              .support-card {
                background: white;
                padding: 32px;
                border-radius: 24px;
                border: 1px solid #e2e8f0;
                text-decoration: none;
                color: inherit;
                display: flex;
                flex-direction: column;
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;
              }
              .support-card:hover {
                transform: translateY(-5px);
                box-shadow: 0 20px 40px rgba(0,0,0,0.05);
                border-color: #278329ff;
              }
              .icon-box {
                width: 50px;
                height: 50px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20px;
                margin-bottom: 20px;
              }
              .primary-card { background: #0f172a; color: white; }
              .arrow-link {
                margin-top: 20px;
                display: flex;
                align-items: center;
                gap: 8px;
                font-weight: 700;
                font-size: 14px;
                color: #278329ff;
              }
              .primary-card .arrow-link { color: #4ade80; }
            `}
          </style>

          <div style={{ flex: "1 1 500px" }} className="animated-left">
            <h1 style={{ fontSize: "40px", fontWeight: 700, color: "#111827", lineHeight: "1.2", marginBottom: "16px" }}>
              Secure, Scalable Aadhaar <br /> Solutions for <span style={{ color: "#278329ff" }}>Digital India</span>
            </h1>
            <p style={{ fontSize: "18px", color: "#374151", marginBottom: "32px", maxWidth: "600px", lineHeight: "2" }}>
              Empowering Governments and Enterprises with AUA/KUA Authentication & Infrastructure Services.
            </p>
            <button style={{ backgroundColor: "#278329ff", color: "#fff", fontWeight: "600", padding: "12px 24px", borderRadius: "12px", border: "none", cursor: "pointer" }}>
              Get in Touch →
            </button>
          </div>

          <motion.div className="zoom-in" style={{ flex: "1 1 400px", display: "flex", justifyContent: "center", alignItems: "center" ,background:'white',borderRadius:"50%"}} initial={{ scale: 0.9 }} animate={{ scale: 1 }} transition={{ duration: 0.8 }}>
            <img src="assets/onboardingimg.png" alt="Digital India" style={{ width: "100%", maxWidth: "500px", borderRadius: "12px" }} />
          </motion.div>
        </div>
      </div>
    <section>  
        <div
      style={{
        backgroundColor: "#ffffffff", // light gray background
        padding: "40px 0px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "60px",
          maxWidth: "1200px",
          width: "100%",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        {/* Card 1 */}
        <div
          style={{
            flex: "1 1 300px",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#0033cc", // deep blue
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <FaCheckCircle color="#fff" size={30} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
            AUA/KUA Authentication Services
          </h3>
          <p style={{ color: "#6b7280", fontSize: "15px" }}>
            Certified authentication with real-time verification
          </p>
        </div>

        {/* Card 2 */}
        <div
          style={{
            flex: "1 1 300px",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#f97316", // orange
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <FaLock color="#fff" size={28} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
          Data Protection and Encryption 
          </h3>
          <p style={{ color: "#6b7280", fontSize: "15px" }}>
            Protect sensitive data using encryption, strict access controls, and compliant system design.
          </p>
        </div>

        {/* Card 3 */}
        <div
          style={{
            flex: "1 1 300px",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#0033cc", // deep blue
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <FaBuilding color="#fff" size={26} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
            Govt Projects: Telangana & Assam
          </h3>
          <p style={{ color: "#6b7280", fontSize: "15px" }}>
           Trusted partnerships with the Governments of Telangana and Assam.
          </p>
        </div>
      </div>
    </div></section>


       <section style={{ padding: '3rem 2rem', textAlign: 'center', backgroundColor: '#fff' }}>
      <h2 style={{ fontWeight: '700', fontSize: '2.3rem', color: '#000' }}>
        Trusted by Governments, Powered by Innovation
      </h2>

      <p style={{ maxWidth: '900px', margin: '1rem auto', color: '#52657A', fontSize: '1.1rem' }}>
        As a certified Authentication User Agency (AUA) and Know Your Customer User Agency (KUA),
        Transaction Analysts stands at the forefront of India&apos;s digital identity infrastructure.
      </p>

      <p style={{ maxWidth: '1000px', margin: '1rem auto', color: '#52657A', fontSize: '1.1rem' }}>
        Our strategic partnerships with UIDAI and State Governments enable us to deliver seamless,
        secure, and scalable Aadhaar-based authentication services that power critical government
        and enterprise applications across the nation.
      </p>

      <p style={{ maxWidth: '1000px', margin: '1rem auto', color: '#52657A', fontSize: '1.1rem' }}>
        With cutting-edge encryption protocols, real-time authentication capabilities, and unwavering
        compliance standards, we ensure the highest levels of security and reliability for every transaction.
      </p>

      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1rem', marginTop: '2rem' }}>
        <span style={badgeStyle}>UIDAI Certified</span>
        <span style={badgeStyle}>ISO 27001</span>
        <span style={badgeStyle}>99.9% Uptime</span>
        <span style={badgeStyle}>10M+ Transactions</span>
      </div>
    </section>
      {/* 2. THE VISUAL FLOW: HOW IT WORKS (USER-FRIENDLY) */}
      <section style={{ padding: "80px 20px", background: '#fff' }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{ fontSize: '36px', fontWeight: '700' }}>3 Steps to Instant Verification</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '40px' }}>
            {[
              { step: '01', title: 'Smart Capture', desc: 'User provides Aadhaar or ID details via our lightning-fast mobile or web interface.' },
              { step: '02', title: 'Secure Auth', desc: 'Our eKYC Setu bridge connects to UIDAI for sub-second biometric or OTP verification.' },
              { step: '03', title: 'Vault Storage', desc: 'Data is encrypted and stored in your private Aadhaar Data Vault, ready for audits.' }
            ].map((s, i) => (
              <div key={i} style={{ position: 'relative' }}>
                <span style={{ fontSize: '80px', fontWeight: '900', color: '#f1f5f9', position: 'absolute', top: '-40px', left: '0', zIndex: '0' }}>{s.step}</span>
                <div style={{ position: 'relative', zIndex: '1' }}>
                  <h3 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '15px' }}>{s.title}</h3>
                  <p style={{ color: '#64748b', lineHeight: '1.7' }}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3. STRATEGIC IMPACT (USING YOUR GROWTH DATA) */}
      <section style={{ padding: "100px 20px", background: '#0f172a', color: '#fff', borderRadius: '40px', margin: '0 20px' }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '60px', alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: '42px', fontWeight: '800', marginBottom: '24px' }}>Scalability that evolves with India.</h2>
              <p style={{ color: '#94a3b8', fontSize: '18px', lineHeight: '1.6', marginBottom: '32px' }}>
                We don't just process transactions; we build digital bridges. Our infrastructure is projected to handle over **63 Million verifications** by 2027.
              </p>
              <div style={{ display: 'flex', gap: '30px' }}>
                <div>
                  <div style={{ fontSize: '32px', fontWeight: '800', color: '#00b884' }}>239%</div>
                  <div style={{ color: '#94a3b8' }}>Growth Projected</div>
                </div>
                <div style={{ width: '1px', background: '#334155' }}></div>
                <div>
                  <div style={{ fontSize: '32px', fontWeight: '800', color: '#00b884' }}>6.31 Cr</div>
                  <div style={{ color: '#94a3b8' }}>FY 2627 Target</div>
                </div>
              </div>
            </div>
            <div style={{ ...glassStyle, background: 'rgba(255,255,255,0.05)', padding: '40px' }}>
              <h4 style={{ marginBottom: '20px', color: '#00b884' }}>Compliance Checklist</h4>
              <ul style={{ listStyle: 'none', padding: 0, color: '#e2e8f0' }}>
                <li style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}><FiUserCheck color="#00b884"/> UIDAI AUA/KUA Licensed</li>
                <li style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}><FiShield color="#00b884"/> ISO 27001 Certified</li>
                <li style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}><FiLayers color="#00b884"/> ADV Compliance Ready</li>
                <li style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}><FiGlobe color="#00b884"/> Govt of Assam & Telangana Partner</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 4. MODERN SERVICES GRID */}
      {/* <section style={{ padding: "120px 20px" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{ fontSize: '42px', fontWeight: '800', marginBottom: '20px' }}>One Stack. Every Identity.</h2>
            <p style={{ color: '#64748b', fontSize: '18px' }}>Specialized modules for Government and BFSI sectors.</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '30px' }}>
            {[
              { title: 'State-Level Onboarding', desc: 'Custom portals for civil supplies and DITEC initiatives.', icon: <FiCpu />, color: '#3b82f6' },
              { title: 'eKYC Setu Bridge', desc: 'The most reliable TSP bridge for banking-grade authentication.', icon: <FiLayers />, color: '#10b981' },
              { title: 'NE Expansion Ready', desc: 'Regionalized stacks optimized for North-Eastern state operations.', icon: <FiMapPin />, color: '#f43f5e' },
              { title: 'Identity APIs', desc: 'Developer-first APIs for private fintechs and lending apps.', icon: <FiActivity />, color: '#8b5cf6' },
              { title: 'Infrastructure Care', desc: '24/7 Managed services for your production environment.', icon: <FiServer />, color: '#f59e0b' },
              { title: 'Compliance Audit', desc: 'Automated reporting for regulatory peace of mind.', icon: <FiFileText />, color: '#06b6d4' }
            ].map((f, i) => (
              <motion.div key={i} whileHover={{ y: -10 }} style={featureCard}>
                <div style={{ color: f.color, marginBottom: '20px', fontSize: '32px' }}>{f.icon}</div>
                <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '12px' }}>{f.title}</h3>
                <p style={{ color: '#64748b', lineHeight: '1.6' }}>{f.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}
 <section style={{ backgroundColor: '#f6f8fb', padding: '4rem 2rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h2 style={{ fontSize: '36px', fontWeight: '700' }}>Our Aadhaar Services</h2>
        <p style={{ fontSize: '1.1rem', color: '#52657A' }}>
          Comprehensive solutions for secure digital authentication
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        {services.map((service, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              borderRadius: '12px',
              padding: '2rem 1.5rem',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: service.bgColor,
                width: '50px',
                height: '50px',
                margin: '0 auto 1rem',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {service.icon}
            </div>
            <h3 style={{ fontSize: '1.2rem', fontWeight: 600 }}>{service.title}</h3>
            <p style={{ fontSize: '0.95rem', color: '#52657A', marginTop: '0.5rem' }}>{service.desc}</p>
          </div>
        ))}
      </div>
    </section>


       <section style={{ backgroundColor: '#f6f8fb', padding: '4rem 2rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h2 style={{ fontSize: '2.3rem', fontWeight: '700' }}>Security & Compliance</h2>
        <p style={{ fontSize: '1.1rem', color: '#52657A' }}>
          Industry-leading security standards and regulatory compliance
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              borderRadius: '12px',
              padding: '2rem 1.5rem',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: item.bgColor,
                width: '50px',
                height: '50px',
                margin: '0 auto 1rem',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {item.icon}
            </div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 600 }}>{item.title}</h3>
            <p style={{ fontSize: '0.95rem', color: '#52657A', marginTop: '0.5rem' }}>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>

 <style>
{`
  @keyframes slideInLeft {
    from {
      transform: translateX(-50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
   @keyframes zoomIn {
            0% {
              transform: scale(0.8);
              opacity: 0;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }

  .slide-left {
    animation: slideInLeft 1s ease forwards;
  }
.zoom-in {
            animation: zoomIn 1s ease-out forwards;
          }

  @media (max-width: 768px) {
    .launch-container section {
      flex-direction: column;
      padding: 1rem !important;
    }

    .launch-left-content {
      padding-left: 0 !important;
      text-align: center;
    }

    .launch-stats {
      justify-content: center;
      gap: 2rem !important;
    }

    .launch-right-card {
      margin-top: 2rem;
    }

    .launch-right-card-inner {
      width: 100% !important;
      max-width: 350px;
    }

    .launch-left-content h1,
    .launch-left-content p {
      text-align: left !important;
    }

    .launch-stats {
      justify-content: flex-start !important;
    }
  }
`}
</style>

<div
  className="launch-container"
  style={{
    background: 'linear-gradient(140deg, #fdfee7ff, #ecfdf5)',
    paddingTop: '40px',
    paddingBottom: '50px',
  }}
>
  <section
    className="container"
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '2rem',
    }}
  >
    {/* Left Content */}
    <div
      className="launch-left-content slide-left"
      style={{
        flex: '1',
        minWidth: '320px',
        maxWidth: '650px',
        paddingLeft: '2rem',
        paddingRight: '2rem',
      }}
    >
      <div className="launch-text">
        <h1
          style={{
            fontSize: '40px',
            fontWeight: '800',
            lineHeight: '1.2',
            marginTop: '20px',
            color: '#0f172a',
          }}
        >
          Launch Financial
        </h1>
        <h1
          style={{
            fontSize: '40px',
            fontWeight: '800',
            lineHeight: '1.2',
            color: 'black',
          }}
        >
          Innovation Faster
        </h1>

        <p
          style={{
            fontSize: '18px',
            color: '#475569',
            marginTop: '1rem',
            maxWidth: '600px',
          }}
        >
          Your Launchpad for Financial Innovation. Transform your business
          with our comprehensive API banking platform designed for modern
          financial services.
        </p>

        {/* Stats */}
        <div
          className="launch-stats"
          style={{
            display: 'flex',
            gap: '5rem',
            marginTop: '3rem',
            textAlign: 'center',
            flexWrap: 'wrap',
          }}
        >
          <div>
            <strong style={{ color: '#059669', fontSize: '2rem' }}>
              99.9%
            </strong>
            <br />
            <span style={{ color: '#475569' }}>Uptime</span>
          </div>
          <div>
            <strong style={{ color: '#6366f1', fontSize: '2rem' }}>
              500+
            </strong>
            <br />
            <span style={{ color: '#475569' }}>API Endpoints</span>
          </div>
          <div>
            <strong style={{ color: '#059669', fontSize: '2rem' }}>
              24/7
            </strong>
            <br />
            <span style={{ color: '#475569' }}>Support</span>
          </div>
        </div>
      </div>
    </div>

    {/* Right Image */}
    <div
      className="launch-right-image zoom-in"
      style={{
        flex: '1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '320px',
        paddingRight: '2rem',
      }}
    >
      <img
        src="/assets/images/apiimg.png"
        alt="Financial Innovation"
        style={{
          maxWidth: '80%',
          height: 'auto',
          borderRadius: '1rem',
          marginLeft: '100px',
        }}
      />
    </div>
  </section>
</div>
{/* <section
  className="info-section"
  style={{
    padding: '4rem 2rem',
    backgroundColor: '#f8fafc',
    textAlign: 'center',
  }}
>
  <div className="container">
    <h2
      style={{
        fontSize: '40px',
        fontWeight: 700,
        color: '#0f172a',
        marginBottom: '1rem',
      }}
    >
      Enabling Financial Disruption
    </h2>
    <p
      style={{
        fontSize: '18px',
        color: '#64748b',
        marginBottom: '2.5rem',
        maxWidth: '540px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      Discover how our platform empowers different industries to innovate and
      transform their financial services.
    </p>

    <div
      className="info-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '2rem',
        justifyItems: 'center',
        padding: '50px 0px',
      }}
    >
      <HoverableInfoCard
        tag="Digital Bank"
        tagColor="#3b82f6"
        title="Are you transforming to become a Digital Bank?"
        description="Leverage our modular API stack to power your digital platform."
      />
      <HoverableInfoCard
        tag="Embedded Finance Solutions"
        tagColor="#10b981"
        title="Are you launching Embedded Finance Solutions?"
        description="Embed new layers & financial products into your services and enter new BFSI-type payment services in the market."
      />
      <HoverableInfoCard
        tag="Healthcare Provider"
        tagColor="#f59e0b"
        title="Are you a Health Care Provider?"
        description="Enable instant payouts, finance flows, and compliance tools."
      />
      <HoverableInfoCard
        tag="Neobank"
        tagColor="#8b5cf6"
        title="Are you Edtech?"
        description="Build & launch your differentiated products or scale your existing platforms with our virtual core."
      />
      <HoverableInfoCard
        tag="E-commerce"
        tagColor="#ef4444"
        title="Are you an E-commerce Payments Provider?"
        description="Integrate seamless checkout, payments, and refunds."
      />
      <HoverableInfoCard
        tag="Insurance"
        tagColor="#06b6d4"
        title="Are you an Insurtech Company?"
        description="Automate claims, premium collection, and policy disbursals."
      />
    </div>
  </div>
</section> */}

<>
  {/* Responsive Styles */}
  <style>
    {`
      @media (max-width: 768px) {
        .finance-section {
          padding: 2rem 1rem !important;
        }

        .finance-section h2 {
          font-size: 1.6rem !important;
        }

        .finance-section p {
          font-size: 1rem !important;
        }

        .finance-circle {
          width: 120px !important;
          height: 120px !important;
          font-size: 0.8rem !important;
        }

        .finance-circle span {
          font-size: 0.9rem !important;
        }

        .finance-grid {
          grid-template-columns: 1fr !important;
          padding: 0 !important;
        }

        .finance-stats {
          grid-template-columns: 1fr !important;
          gap: 1rem !important;
        }
      }
         @media (max-width: 480px) {
        .finance-section h2 {
          font-size: 1.8rem;
        }

        .finance-section p {
          font-size: 1rem;
        }

        .center-circle {
          width: 120px;
          height: 120px;
          font-size: 0.8rem;
        }
      }
  `}
     
  </style>
<section
  style={{
    padding: "4rem 1rem",
    background: "#f8fafc",
  }}
>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
    }}
  >
    {/* Top Badge */}
    <div
      style={{
        display: "inline-block",
        background: "#e0f2fe",
        color: "#0284c7",
        padding: "6px 14px",
        borderRadius: "999px",
        fontSize: "0.8rem",
        marginBottom: "1rem",
        fontWeight: 500,
      }}
    >
      API Setu integration
    </div>

    {/* Heading */}
    <h2
      style={{
        fontSize: "2.2rem",
        fontWeight: 700,
        marginBottom: "1rem",
      }}
    >
   Identity & Verification APIs
    </h2>

    {/* Subtext */}
    <p
      style={{
        maxWidth: "700px",
        color: "#6b7280",
        marginBottom: "2.5rem",
      }}
    >
      Expose multiple public-sector data rails through one polished developer
      workflow with clear request flows, sandbox tooling, and response observability.
    </p>

    {/* Main Card */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1.2fr 1fr",
        gap: "2rem",
        background: "#ffffff",
        borderRadius: "1.5rem",
        padding: "2rem",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      }}
    >
      {/* LEFT SIDE */}
      <div>
        <div
          style={{
            display: "inline-block",
            background: "#e0f2fe",
            color: "#0284c7",
            padding: "5px 12px",
            borderRadius: "999px",
            fontSize: "0.75rem",
            marginBottom: "1rem",
          }}
        >
          Government API flow diagram
        </div>

        <h3 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>
          Connect PAN, TAN, GST, banking, and identity services through a unified API platform
        </h3>

        {/* Chips */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "1rem",
          }}
        >
          {[
            "PAN Verification",
            "TAN Verification",
            "GST Verification",
            "Name Match",
            "Name Validate",
            "Penny Drop",
            "SMS Service",
            "DigiLocker",
          ].map((item, i) => (
            <div
              key={i}
              style={{
                padding: "10px 14px",
                background: "#f1f5f9",
                borderRadius: "12px",
                fontSize: "0.85rem",
                fontWeight: 500,
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#e0f2fe";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#f1f5f9";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              {item}
            </div>
          ))}
        </div>

        {/* Description */}
        <p
          style={{
            color: "#6b7280",
            fontSize: "0.9rem",
            marginBottom: "1.5rem",
          }}
        >
          Integrate PAN, TAN, GST, Name Match, Penny Drop, SMS, and DigiLocker
          services into a single orchestration layer with standardized APIs and real-time responses.
        </p>

        {/* Button */}
        <button
          style={{
            background: "#f59e0b",
            color: "#fff",
            padding: "10px 18px",
            borderRadius: "10px",
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
            transition: "0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#d97706")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#f59e0b")}
        >
          Try Sandbox
        </button>
      </div>

      {/* RIGHT SIDE */}
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {/* JSON Card */}
        <div
          style={{
            background: "#0f172a",
            color: "#22c55e",
            padding: "1rem",
            borderRadius: "1rem",
            fontFamily: "monospace",
            fontSize: "0.85rem",
          }}
        >
{`{
  "api": "pan_verify",
  "response_time_ms": 412,
  "match": "success",
  "trace_id": "setu_x19a"
}`}
        </div>

        {/* Response Card */}
        <div
          style={{
            background: "#f8fafc",
            borderRadius: "1rem",
            padding: "1rem",
            border: "1px solid #e5e7eb",
          }}
        >
          <p style={{ marginBottom: "6px", color: "#6b7280" }}>
            API response card
          </p>
          <p>
            Status:{" "}
            <strong style={{ color: "#16a34a" }}>200 OK</strong>
          </p>
          <p>Connector: PAN + DigiLocker</p>
          <p>Format: JSON / XML</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section
  style={{
    padding: "4rem 1rem",
    background: "#eef6fb",
  }}
>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "1.1fr 1fr",
      gap: "2rem",
      alignItems: "center",
    }}
  >
    {/* LEFT SIDE */}
    <div>
      {/* Badge */}
      <div
        style={{
          display: "inline-block",
          background: "#e0f2fe",
          color: "#0284c7",
          padding: "6px 14px",
          borderRadius: "999px",
          fontSize: "0.8rem",
          marginBottom: "1rem",
        }}
      >
         CKYC services
      </div>

      {/* Heading */}
      <h2
        style={{
          fontSize: "2.2rem",
          fontWeight: 700,
          marginBottom: "1rem",
        }}
      >
        CKYC Integration for Unified Customer Verification
      </h2>

      {/* Subtext */}
      <p
        style={{
          color: "#6b7280",
          marginBottom: "2rem",
          maxWidth: "550px",
        }}
      >
        Bring CKYC data retrieval, onboarding reuse, and identity deduplication
        into the same operational surface as Aadhaar and document verification APIs.
      </p>

      {/* Feature Cards */}
      {[
        {
          title: "CKYC Search API",
          desc: "Search centralized records to accelerate existing-customer verification.",
          color: "#0284c7",
        },
        {
          title: "CKYC Download (XML/PDF)",
          desc: "Retrieve structured or printable records for downstream processing.",
          color: "#10b981",
        },
        {
          title: "Customer Onboarding via CKYC",
          desc: "Prefill journeys and reduce repetitive document collection.",
          color: "#f97316",
        },
        {
          title: "Deduplication & Identity Match",
          desc: "Detect duplicates and strengthen identity matching across systems.",
          color: "#6366f1",
        },
      ].map((item, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            background: "#fff",
            padding: "1rem",
            borderRadius: "12px",
            marginBottom: "1rem",
            boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
          }}
        >
          {/* Icon Circle */}
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: item.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            •
          </div>

          {/* Text */}
          <div>
            <h4 style={{ margin: 0, fontSize: "1rem" }}>{item.title}</h4>
            <p style={{ margin: 0, fontSize: "0.85rem", color: "#6b7280" }}>
              {item.desc}
            </p>
          </div>
        </div>
      ))}

      {/* Bottom Tags */}
      <div style={{ display: "flex", gap: "10px", marginTop: "1rem" }}>
        <div
          style={{
            background: "#d1fae5",
            color: "#065f46",
            padding: "6px 12px",
            borderRadius: "999px",
            fontSize: "0.75rem",
          }}
        >
          Reduce onboarding time by 70%
        </div>
        <div
          style={{
            background: "#e0f2fe",
            color: "#0369a1",
            padding: "6px 12px",
            borderRadius: "999px",
            fontSize: "0.75rem",
          }}
        >
          RBI compliant KYC flow
        </div>
      </div>
    </div>

    {/* RIGHT SIDE */}
    <div
      style={{
        background: "#ffffff",
        borderRadius: "1.5rem",
        padding: "2rem",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "1rem",
      }}
    >
      {/* Left Card */}
      <div
        style={{
          background: "linear-gradient(135deg,#1e3a8a,#2563eb)",
          color: "#fff",
          padding: "1.5rem",
          borderRadius: "1rem",
          width: "45%",
        }}
      >
        <p style={{ fontSize: "0.75rem", opacity: 0.8 }}>CKYC vault</p>
        <h3 style={{ margin: "0.5rem 0" }}>Unified identity source</h3>
        <p style={{ fontSize: "0.8rem" }}>
          Centralized records powering faster user verification.
        </p>
      </div>

      {/* Arrow */}
      <div style={{ fontSize: "1.5rem", color: "#10b981" }}>→</div>

      {/* Right Card */}
      <div
        style={{
          background: "#f8fafc",
          padding: "1.5rem",
          borderRadius: "1rem",
          width: "45%",
          border: "1px solid #e5e7eb",
        }}
      >
        <p style={{ fontSize: "0.75rem", color: "#0284c7" }}>
          Onboarding orchestration
        </p>
        <h3 style={{ margin: "0.5rem 0" }}>Instant customer reuse</h3>
        <p style={{ fontSize: "0.8rem", color: "#6b7280" }}>
          Search, fetch, match, and prefill across digital channels.
        </p>
      </div>
    </div>
  </div>
</section>
<section
  className="finance-section"
  style={{
    padding: '4rem 1rem',
    background: 'linear-gradient(to bottom right, #f4fdf8, #f1f5f9)',
    textAlign: 'center',
  }}
>
  <div
    className="container"
    style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1rem',
    }}
  >
    <h2 style={{ fontSize: '40px', fontWeight: '700' }}>
      Revolutionizing{' '}
      <span style={{ color: '#3e7235ff', fontSize: '2.3rem' }}>
        Access to Finance
      </span>
    </h2>

    <p
      style={{
        maxWidth: '1000px',
        margin: '1rem auto 3rem',
        fontSize: '18px',
        color: '#6b7280',
        lineHeight: '1.6',
      }}
    >
      Our platform is built on the innovative{' '}
     
        India Stack
      to ensure a robust digital infrastructure that is secure, resilient, and
      scalable. We have architected the platform to enable innovation & choice
      for customers.
    </p>

    {/* Center Circle */}
    <div
      className="finance-circle"
      style={{
        width: '160px',
        height: '160px',
        margin: '0 auto 2.5rem',
        background: 'linear-gradient(145deg, #2a7861ff, #577dfaff)',
        color: 'white',
        borderRadius: '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: '600',
        fontSize: '0.95rem',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        lineHeight: '1.2',
      }}
    >
      <span
        style={{
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '50%',
          color: '#18552cff',
          fontSize: '20px',
        }}
      >
        TA
        <br />
      </span>
      <span style={{ fontSize: '1rem', fontWeight: 'bold' }}>
        Transaction Analysts
      </span>
      <br />
      Secure Core
    </div>

    {/* Feature Cards Grid */}
 <div
  className="finance-grid"
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)', // ✅ 4 cards in one row
    gap: '1.5rem',
    marginTop: '2rem',
  }}
>
  {features.map((item, index) => (
    <FeatureCard key={index} item={item} />
  ))}
</div>

    {/* Stats Grid */}
    <div
      className="finance-stats"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '1.5rem',
        marginTop: '3rem',
      }}
    >
      {stats.map((stat, index) => (
        <div
          key={index}
          style={{
            background: 'white',
            padding: '1.5rem 1rem',
            borderRadius: '1rem',
            boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
            transition: '0.3s',
            textAlign: 'center',
          }}
        >
          <div style={{ marginBottom: '0.5rem' }}>{stat.icon}</div>
          <strong style={{ fontSize: '28px', color: '#111827' }}>
            {stat.value}
          </strong>
          <p style={{ fontSize: '18px', color: '#6b7280' }}>
            {stat.label}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
</>

<section
  className="baas-section"
  style={{
    textAlign: 'center',
    padding: '4rem 1rem',
    backgroundColor: '#f6f5ff',
  }}
>
  <div
    className="container"
    style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1rem',
    }}
  >
    <h2
      style={{
        fontSize: '2.2rem',
        fontWeight: '700',
        marginBottom: '1rem',
      }}
    >
      Banking as a Service
    </h2>

    <p
      style={{
        maxWidth: '800px',
        margin: '0 auto 2rem',
        color: '#6b7280',
        fontSize: '1rem',
        lineHeight: '1.6',
      }}
    >
      Banking as a Service (BaaS) is reconfiguring the banking value chain and
      enabling new innovative services to be rapidly taken to the marketplace.
      Banks are embedding fintech products into the customer journey instead of
      just making companies introduce banking products into their services.
    </p>

    {/* Top Row Cards */}
    <div className="baas-cards">
      {topCards.map((card, index) => (
        <BaasCard key={index} {...card} />
      ))}
    </div>

    {/* Arrows Row */}
    <div className="arrow-row">
      {Array.from({ length: 5 }).map((_, index) => (
        <div className="arrow" key={index}>
          ↓
        </div>
      ))}
    </div>

    {/* Middle Platform Card */}
    <div className="baas-banner green-blue">
      <h3>TA – BAAS – Platform</h3>
      <p>Comprehensive Banking Infrastructure</p>
    </div>

    {/* Arrows Row */}
    <div className="arrow-row">
      {Array.from({ length: 5 }).map((_, index) => (
        <div className="arrow" key={index}>
          ↓
        </div>
      ))}
    </div>

    {/* Bottom Row Cards */}
    <div className="baas-cards">
      {bottomCards.map((card, index) => (
        <BaasCard key={index} {...card} />
      ))}
    </div>

    {/* Final Footer Banner */}
    <div className="baas-banner blue-green">
      <h3>Digital Services to any Company</h3>
      <p>Scalable Solutions for Every Business</p>
    </div>
  </div>

  {/* Keyframes for bounce animation */}
  <style>
    {`
      @keyframes bounceDown {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(8px); }
      }

      .baas-cards {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1.5rem;
        margin-bottom: 2rem;
      }

      .arrow-row {
        display: flex;
        justify-content: center;
        gap: 1.5rem;
        margin-bottom: 1.5rem;
        animation: bounceDown 1.5s infinite;
      }

      .arrow {
        font-size: 2rem;
        color: #9ca3af;
      }

      .baas-banner {
        border-radius: 1rem;
        padding: 1.5rem;
        margin: 2rem auto;
        max-width: 1100px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        color: white;
      }

      .green-blue {
        background: linear-gradient(to right, #059669, #0ea5e9);
      }

      .blue-green {
        background: linear-gradient(to right, #1a5747ff, #3b82f6);
        margin-top: 2rem;
      }

      .baas-banner h3 {
        font-size: 1.4rem;
        margin-bottom: 0.25rem;
      }

      .baas-banner p {
        font-size: 1rem;
      }

      @media (max-width: 768px) {
        .arrow {
          font-size: 1.5rem;
        }

        .baas-banner h3 {
          font-size: 1.2rem;
        }

        .baas-banner p {
          font-size: 0.95rem;
        }

        .baas-cards {
          flex-direction: column;
          align-items: center;
        }
      }

      @media (min-width: 1440px) {
        .baas-section h2 {
          font-size: 2.5rem;
        }

        .baas-banner h3 {
          font-size: 1.6rem;
        }

        .baas-banner p {
          font-size: 1.05rem;
        }
      }
    `}
  </style>
</section>
  <section
      style={{
        textAlign: 'center',
        padding: '4rem 1rem',
        background: '#f9fafb',
        fontFamily: 'sans-serif',
      }}
    >
      <h2
        style={{
          fontSize: '1.9rem',
          marginBottom: '0.5rem',
          fontWeight: '700',
          color: '#111827',
        }}
      >
        Accelerate Time-to-Market with our <strong>Sandbox</strong>
      </h2>

      <p
        style={{
          maxWidth: '700px',
          margin: '0 auto 2rem auto',
          color: '#4b5563',
          fontSize: '1rem',
          lineHeight: '1.6',
        }}
      >
        We have set up a dedicated testing environment to help you test drive your
        next-phase solutions prior to launch in the marketplace. Test your
        applications and simulate your regulatory tasks in a practical manner.
      </p>

      {/* Card */}
      <div
        style={{
          maxWidth: '940px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 6px 24px rgba(0, 0, 0, 0.08)',
          border: '5px solid #4faea2ff',
        }}
      >
        {/* Circle */}
        <div
          style={{
            width: '70px',
            height: '70px',
            borderRadius: '50%',
            margin: '0 auto 1rem auto',
            background: 'radial-gradient(circle at center, #1e3a8a 40%, #60a5fa 100%)',
            
          }}
        />

        {/* Title */}
       <h3
  style={{
    fontSize: '1.8rem',
    fontWeight: '600',
    marginBottom: '2rem',
    background: 'linear-gradient(to right, #1a5747ff, #3b82f6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  }}
>
  Developer Sandbox Environment
</h3>


        {/* Description */}
        <p
          style={{
            fontSize: '1.2rem',
            color: '#4b5563',
            marginBottom: '1.5rem',
            lineHeight: '1.5',
          }}
        >
          We offer a variety of support tools to accelerate your go-to-market timeline
          including API documentation, developer guides and release notes. You can even
          take our APIs for a spin. And because the time-to-value for your solution.
        </p>

        {/* Stats */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '1rem',
            textAlign: 'center',
            marginBottom: '1.5rem',
            flexWrap: 'wrap',
          }}
        >
          {/* Stat 1 */}
           <div
            style={{
              flex: '1 1 30%',
              background: '#f3f4f6',
              borderRadius: '12px',
              padding: '1.5rem',
            }}
          >
            <strong
              style={{
                fontSize: '1.9rem',
                color: '#10b981',
                fontWeight: '700',
                display: 'block',
                marginBottom: '0.25rem',
              }}
            >
             24/7
            </strong>
            <p style={{ fontSize: '0.85rem', color: '#4b5563', margin: 0 }}>
             Sandbox Access<br />
              Always Available
            </p>
          </div>


          {/* Stat 2 */}
          <div
            style={{
              flex: '1 1 30%',
              background: '#f3f4f6',
              borderRadius: '12px',
              padding: '1.5rem',
            }}
          >
            <strong
              style={{
                fontSize: '1.9rem',
                color: '#10b981',
                fontWeight: '700',
                display: 'block',
                marginBottom: '0.25rem',
              }}
            >
              100+
            </strong>
            <p style={{ fontSize: '0.85rem', color: '#4b5563', margin: 0 }}>
              API Endpoints<br />
              Full Documentation
            </p>
          </div>

          {/* Stat 3 */}
          <div
            style={{
              flex: '1 1 30%',
              background: '#f3f4f6',
              borderRadius: '12px',
              padding: '1.5rem',
            }}
          >
            <strong
              style={{
                fontSize: '1.9rem',
                color: '#10b981',
                fontWeight: '700',
                display: 'block',
                marginBottom: '0.25rem',
              }}
            >
              15min
            </strong>
            <p style={{ fontSize: '0.85rem', color: '#4b5563', margin: 0 }}>
              Quick Setup<br />
              Instant Access
            </p>
          </div>
        </div>

       {/* Button */}
<button
  style={{
    background: 'linear-gradient(to right, #1a5747ff, #3b82f6)',
    color: 'white',
    border: 'none',
    padding: '0.6rem 1.5rem',
    borderRadius: '8px',
    fontWeight: 700,
    marginTop:"20px",
    cursor: 'pointer',
    fontSize: '1.2rem',
  }}
>
  Access Sandbox Now
</button>

      </div>

   
    </section>
    {/* <section className="terms-section">
  <style>{`
    .terms-section {
      padding: 40px 10px;
      background: #f8fafc;
    }

    .terms-container {
      max-width: 1200px;
      margin: 0 auto;
    }

    .terms-heading {
      font-size: 36px;
      font-weight: 700;
      margin-bottom: 30px;
      color: #111827;
      text-align: left;
    }

    .terms-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .terms-item {
      background: #ffffff;
      padding: 15px 20px;
      border-radius: 16px;
      text-decoration: none;
      color: #065f46;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
    }

    .terms-item:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
    }

    .terms-left {
      display: flex;
      align-items: center;
      gap: 14px;
      font-size: 18px;
      font-weight: 500;
    }

    .terms-icon {
      background: #d1fae5;
      color: #065f46;
      padding: 10px;
      border-radius: 10px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .terms-arrow {
      font-size: 24px;
      color: #065f46;
      font-weight: bold;
    }

    @media (max-width: 768px) {
      .terms-heading {
        font-size: 26px;
        text-align: center;
      }

      .terms-item {
        padding: 16px 18px;
      }

      .terms-left span {
        font-size: 15px;
      }
    }
  `}</style>

  <div className="terms-container">

    <h3 className="terms-heading">
        Policies & Agreements
    </h3>

    <div className="terms-list">

      <a href="/docs/terms-english" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms & Conditions – English</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/terms-hindi" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms & Conditions – Hindi</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/terms-kannada" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms & Conditions – Kannada</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/csr-agreement" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms of Reference of CSR Program Tripartite Agreement</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

    </div>

  </div>
</section> */}

    <section className="ta-support-section">
           <div className="ta-support-container ">
             
             {/* Header Area */}
             <div className="ta-support-header">
               <span className="ta-support-badge">Onboarding Stack Help Center</span>
               <h3><b>Dedicated Onboarding Helpdesk</b></h3>
               <p className="ta-support-subtext">
               Get sub-second response times for mission-critical production issues.
               </p>
             </div>
     
             {/* Support Cards Grid */}
             <div className="ta-support-grid">
               
               {/* Card 1: Phone (Click to Call) */}
               <div className="ta-support-card">
                 <div className="ta-card-icon phone-icon">
                   <FaPhoneAlt />
                 </div>
                 <div className="ta-card-content">
                   <h3>Nodal Officer</h3>
                   <p>+91 8919056119</p>
                   <small>Immediate voice assistance for API integration and network white-listing</small>
                 </div>
                 <div className="ta-card-arrow">
                   <FaArrowRight />
                 </div>
               </div>
     
               {/* Card 2: Email (Click to Email) */}
               <div className="ta-support-card">
                 <div className="ta-card-icon email-icon">
                   <FaEnvelopeOpenText />
                 </div>
                 <div className="ta-card-content">
                   <h3>Nodal Officer Email</h3>
                   <p>kirankumar.p@taipl.in</p>
                   <small>Send logs, screenshots, or documentation requests to our core team.</small>
                 </div>
                 <div className="ta-card-arrow">
                   <FaArrowRight />
                 </div>
               </div>
     
               {/* Card 3: Ticket (Primary Action) */}
               <a href="https://udir.transactionanalysts.com/customergrievance" target="_blank" rel="noopener noreferrer" className="ta-support-card ta-card-primary">
                 <div className="ta-card-icon ticket-icon">
                   <FaHeadset />
                 </div>
                 <div className="ta-card-content">
                   <h3>Raise a Dispute</h3>
                   <p>Open Portal</p>
                   <small>For failed transactions, settlement queries, or state-level onboarding tickets.</small>
                 </div>
                 <div className="ta-card-arrow">
                   <FaArrowRight />
                 </div>
               </a>
     
             </div>
           </div>
         </section>
    </div>
  );
};

export default OnboardingStack;